import { EntityAddForm, EntityAddFormPage } from "../../../common/entity/EntityAddForm";
import { EntityEditForm, EntityEditFormPage } from "../../../common/entity/EntityEditForm";
import { EntityEditFormProps } from "../../../common/entity/EntityInterfaces";
import { ZontalCredentialsForm } from "./ZontalCredentialsForm";

// Add
export const ZontalCredentialAddForm = () => {
  return (
    <EntityAddForm entityTypeId={"zontalCredentials"}>{(props) => <ZontalCredentialsForm {...props} />}</EntityAddForm>
  );
};

export const ZontalCredentialAddFormPage = () => {
  return (
    <EntityAddFormPage>
      <ZontalCredentialAddForm />
    </EntityAddFormPage>
  );
};

// Edit
export const ZontalCredentialEditForm = ({ id }: EntityEditFormProps<"zontalCredentials">) => {
  return (
    <EntityEditForm id={id} entityTypeId={"zontalCredentials"} filters={{}}>
      {(props) => <ZontalCredentialsForm {...props} />}
    </EntityEditForm>
  );
};

export const ZontalCredentialEditFormPage = () => {
  return (
    <EntityEditFormPage<"zontalCredentials"> isIntId>{(id) => <ZontalCredentialEditForm id={id} />}</EntityEditFormPage>
  );
};
